import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'download-guide',
  templateUrl: './download-guide.component.html',
  styleUrls: ['./download-guide.component.css']
})
export class DownloadGuideComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
